import { Notification } from '@app/components/various/Notification';
import { useTranslation } from 'react-i18next';

export const CreditLimitExceededFailure = () => {
  const { t } = useTranslation(['checkoutMessages']);

  return (
    <div className="flex w-full flex-col gap-5">
      <Notification type="error" message={t('checkoutMessages:credit_limit_exceeded.header')} />
      <p className="whitespace-pre-wrap body-2">{t('checkoutMessages:credit_limit_exceeded.details')}</p>
    </div>
  );
};
